<template>
  <div>
    <el-dialog
      title="Tìm FOLIO để chuyển giao dịch"
      :visible.sync="searchFolioDialog"
      :close-on-click-modal="false"
      width="900px"
      @close="resetSearchFolioDialog"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Tìm thông tin</div>
          <hr />
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Tên khách</div>
                <input v-model="searchParamsFolio.customerInfo" type="text" />
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Tên đoàn</div>
                <input v-model="searchParamsFolio.groupInfo" type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Hạng/Số phòng</div>
                <div style="display: flex; gap: 10px">
                  <el-select
                    v-model="searchParamsFolio.roomLevelId"
                    placeholder=""
                    @change="roomLevelChange"
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in roomLevelOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select v-model="searchParamsFolio.roomId" placeholder="">
                    <el-option :key="9999" :value="null" label="Tất cả" />
                    <el-option
                      v-for="item in roomOptions"
                      :key="item.id"
                      :label="item.room_num"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <!-- <select v-model="searchParamsFolio.roomId">
                    <option :value="null">Tất cả</option>
                  </select> -->
                </div>
              </div>
            </div>
            <!-- <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="das-form-input">
                  <div class="label">ID thành viên</div>
                  <input v-model="searchParamsFolio.guestNum" type="text" />
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="das-form-group">
          <div class="das-form-group-title">Tìm kiếm nâng cao</div>
          <hr />
          <div class="das-form-row">
            <div class="flex gap-20">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Họ</div>
                  <input
                    v-model="searchParamsFolioAdvance.last_name"
                    type="text"
                  />
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Tên</div>
                  <input
                    v-model="searchParamsFolioAdvance.first_name"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Quốc gia</div>
                <el-select
                  v-model="searchParamsFolioAdvance.nation_id"
                  filterable
                  placeholder=""
                >
                  <el-option :key="9999" :value="null" label="Tất cả" />
                  <el-option
                    v-for="item in nationOptions"
                    :key="item.id"
                    :label="`${item.code} - ${item.desc}`"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Công ty</div>
                <el-select
                  v-model="searchParamsFolioAdvance.agent_id"
                  filterable
                  placeholder=""
                >
                  <el-option :key="9999" :value="null" label="Tất cả" />
                  <el-option
                    v-for="item in agentOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Phân khúc thị trường</div>
                <el-select
                  v-model="searchParamsFolioAdvance.market_seg_id"
                  filterable
                  placeholder=""
                >
                  <el-option :key="9999" :value="null" label="Tất cả" />
                  <el-option
                    v-for="item in segmentOptions"
                    :key="item.id"
                    :label="`${item.code} - ${item.desc}`"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <!-- <select v-model="searchParamsFolioAdvance.market_seg_id">
                  <option :value="null">Tất cả</option>
                </select> -->
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ngày đến</div>
                <MultiCalendar
                  ref="multiCalendar1"
                  class="use-icon"
                  :from-date="searchParams.arrive_from"
                  :to-date="searchParams.arrive_to"
                  @changeDate="onChangeComeDateFolioSearch"
                />
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ngày đi</div>
                <MultiCalendar
                  class="use-icon"
                  :from-date="searchParams.depart_from"
                  :to-date="searchParams.depart_to"
                  @changeDate="onChangeComeDepartFolioSearch"
                />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <!-- <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Giá theo mã gói</div>
                <div style="display: flex; gap: 10px">
                  <el-select
                    v-model="searchParamsFolioAdvance.price_code_id"
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                  </el-select>
                  <el-select
                    v-model="searchParamsFolioAdvance.price_code_id"
                    placeholder=""
                  >
                    <el-option :key="9999" :value="null" label="Tất cả" />
                  </el-select>
                </div>
              </div>
            </div> -->
            <!-- <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Đại lý du lịch/AR</div>
                <input
                  v-model="searchParamsFolioAdvance.agent_id"
                  type="text"
                />
              </div>
            </div> -->
          </div>
        </div>
        <!-- <div class="das-form-group">
          <div class="das-form-group-title">Trạng thái đặt phòng</div>
          <hr /> -->
        <!-- <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch1"
                    v-model="searchParamsFolioAdvance.booked"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch1">Đã đặt</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch2"
                    v-model="searchParamsFolioAdvance.is_checked_out_today"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch2">Đã trả phòng hôm nay</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch3"
                    v-model="searchParamsFolioAdvance.is_canceled"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch3">Đã hủy</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch4"
                    v-model="searchParamsFolioAdvance.is_arrive_today"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch4">Đến hôm nay</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch5"
                    v-model="searchParamsFolioAdvance.is_not_arrive"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch5">Không đến</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch6"
                    v-model="searchParamsFolioAdvance.in_house"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch6">Đang ở</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch7"
                    v-model="searchParamsFolioAdvance.is_checkout"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch7">Đã trả phòng</label>
                </div>
              </div>
            </div>
          </div> -->
        <!-- <div class="das-form-row align-end">
            <div class="das-form-col col-12">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch8"
                    v-model="searchParamsFolioAdvance.is_definite"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch8">Definite</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch9"
                    v-model="searchParamsFolioAdvance.is_waiting"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch9">Waiting</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch10"
                    v-model="searchParamsFolioAdvance.is_tentative"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch10">Tentatvie</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="advanceFolioSearch11"
                    v-model="searchParamsFolioAdvance.exactly"
                    type="checkbox"
                  />
                  <label for="advanceFolioSearch11">Chính xác</label>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="searchFolioDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="searchFolio">
            Tìm kiếm
          </button>
          <button class="btn primary small" @click="searchFolioAdvance">
            Tìm kiếm nâng cao
          </button>
        </div>
      </span>
    </el-dialog>
    <!-- List Folio Popup -->
    <el-dialog
      title="Danh sách FOLIO để chuyển giao dịch"
      :visible.sync="folioListDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="folioListGrid"
          :columns="folioListCols"
          dom-layout="scroll"
          :rows="folioListRows"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="folioListDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onFolioSelect()">
            Chọn
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { getCodeBase } from '@/api/common/code_base'
import { getMarketSegmentApi } from '@/api/Statistics/marketSegment'
import { getListAgentApi } from '@/api/configuration/profile/agent.js'
import {
  searchFolioApi,
  searchFolioAdvanceApi
} from '@/api/cashier_service/postTransaction'
import { getRoomLevel, getRoom } from '@/api/reception/common'
export default {
  props: {
    searchFolioComponentIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      folioListDialog: false,
      agentOptions: [],
      segmentOptions: [],
      roomLevelOptions: [],
      nationOptions: [],
      roomOptions: [],
      folioListRows: [],
      searchFolioDialog: false,
      searchParamsFolio: {
        customerInfo: null,
        groupInfo: null,
        roomLevelId: null,
        roomId: null,
        guestNum: null
      },
      searchParams: {
        customer_info: null,
        company_info: null,
        arrive_from: null,
        arrive_to: null,
        depart_from: null,
        depart_to: null,
        surplus: null,
        check_out_today: null,
        reserved: null,
        in_house: true,
        checked_out: null
      },
      searchParamsFolioAdvance: {
        first_name: null,
        last_name: null,
        price_code_id: null,
        arrive_date_from: null,
        arrive_date_to: null,
        depart_date_from: null,
        depart_date_to: null,
        agent_name: null,
        agent_id: null,
        nation_id: null,
        market_seg_id: null,
        booked: false,
        is_arrive_today: false,
        is_not_checkout: false,
        is_checked_out_today: false,
        is_checkout: false,
        is_canceled: false,
        is_not_arrive: false,
        is_definite: false,
        is_tentative: false,
        is_waiting: false,
        exactly: false
      },
      folioListCols: [
        {
          headerName: this.$t('grid.column.reservation'),
          field: 'room_code',
          tooltipField: 'room_code',
          maxWidth: 130
        },
        // {
        //   headerName: this.$t('grid.column.confirm'),
        //   field: 'confirm_code',
        //   tooltipField: 'confirm_code',
        //   width: 150
        // },
        {
          headerName: this.$t('grid.column.name'),
          field: 'full_name',
          tooltipField: 'full_name',
          width: 150
        },
        {
          headerName: this.$t('grid.column.vip'),
          field: 'vip',
          width: 100,
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num',
          tooltipField: 'room_num',
          width: 150
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          tooltipField: 'room_level',
          width: 150
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date',
          valueGetter: param => {
            if (param.data?.arrive_date) {
              return this.$displayDate(param.data.arrive_date)
            } else {
              return null
            }
          },
          width: 150
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date',
          valueGetter: param => {
            if (param.data?.depart_date) {
              return this.$displayDate(param.data.depart_date)
            } else {
              return null
            }
          },
          width: 150
        },
        {
          headerName: 'NL/TE',
          // field: 'nl',
          valueGetter: param => {
            return `${param?.data?.nl || 0}/${param?.data?.te || 0}`
          },
          maxWidth: 80
        },
        {
          headerName: this.$t('grid.column.group'),
          field: 'group_code',
          tooltipField: 'group_code',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.companyName'),
          field: 'agent_name',
          tooltipField: 'agent_name',
          minWidth: 250
        }
      ]
    }
  },
  watch: {
    async searchFolioComponentIndex() {
      await this.getOptionForFolioSearch()
    }
  },
  methods: {
    resetSearchFolioDialog() {
      this.$nullValueInObj(this.searchParamsFolio)
      this.$nullValueInObj(this.searchParamsFolioAdvance)
      this.$refs.multiCalendar1.onReset()
    },
    async roomLevelChange(id) {
      const params = {
        roomLevelId: id
      }
      const data5 = await getRoom(params)
      this.roomOptions = data5.data || []
    },
    onChangeComeDateFolioSearch(from, to) {
      this.searchParamsFolioAdvance.arrive_date_from = from
      this.searchParamsFolioAdvance.arrive_date_to = to
    },
    onChangeComeDepartFolioSearch(from, to) {
      this.searchParamsFolioAdvance.depart_date_from = from
      this.searchParamsFolioAdvance.depart_date_to = to
    },
    async getOptionForFolioSearch() {
      const data1 = await getCodeBase({
        p_code: 'NATION'
      })
      this.nationOptions = data1.data
      const data2 = await getMarketSegmentApi({
        isActive: 1
      })
      this.segmentOptions = data2.data
      const data3 = await getListAgentApi()
      this.agentOptions = data3.data

      const dat4 = await getRoomLevel()
      this.roomLevelOptions = dat4?.data || []
      const data5 = await getRoom()
      this.roomOptions = data5.data
    },
    async searchFolio() {
      const data = await searchFolioApi(this.searchParamsFolio)
      this.folioListRows = data?.data || []
      if (this.folioListRows.length === 0) {
        this.$message({
          type: 'warning',
          message: 'Không có dữ liệu'
        })
        return
      }
      this.folioListDialog = true
    },
    async searchFolioAdvance() {
      const data = await searchFolioAdvanceApi(this.searchParamsFolioAdvance)
      this.folioListRows = data?.data || []
      if (this.folioListRows.length === 0) {
        this.$message({
          type: 'warning',
          message: 'Không có dữ liệu'
        })
        return
      }
      this.folioListDialog = true
    },
    onFolioSelect() {
      // this.searchFolioType = type
      const agGrid = this.$refs.folioListGrid.gridApi
      const row = agGrid.getSelectedRows()[0]
      this.$emit('onFolioSelect', row)
      // if (this.searchFolioType === 1) {
      //   this.createRoutingForm.sub_booking_group_id_des = row.id
      //   this.createRoutingForm.sub_booking_group_name_des = row.full_name
      // } else {
      //   this.transferTransactionSubmitForm.sub_booking_group_id = row.id
      //   this.transferTransactionSubmitForm.room_code = row.room_code
      //   this.transferTransactionSubmitForm.customer_name = row.full_name
      //   this.transferTransactionSubmitForm.room_num = row.room_num
      // }

      this.folioListDialog = false
      this.searchFolioDialog = false
      // this.resetFolioSearchDialog()
    }
  }
}
</script>
